__turbopack_context__.v({
  "btn": "styles-module-scss-module__fzntza__btn",
  "desctop": "styles-module-scss-module__fzntza__desctop",
  "desctop_block": "styles-module-scss-module__fzntza__desctop_block",
  "desctop_block_mob": "styles-module-scss-module__fzntza__desctop_block_mob",
  "root": "styles-module-scss-module__fzntza__root",
});
